<template>
  <SfDocumentPill
    data-testid="ai-ocr-document-pill"
    :allow-delete="true"
    :delete-tooltip="I18n.t('ai_ocr_documents.document_pill.delete')"
    :viewing-url="viewingUrl"
    :viewing-tooltip="I18n.t('ai_ocr_documents.document_pill.view')"
    @delete="handleDelete"
  >
    <template #left-icon>
      <i
        v-if="isProposedDocument"
        v-tooltip="I18n.t('ai_ocr_documents.document_pill.magic_wand')"
        class="
          icon icon-magic
          tw-text-xs tw-leading-4 tw-text-sf-gray-light
          hover:tw-text-sf-gray-light
        "
        data-testid="document-pill-magic-wand"
      ></i>
    </template>
    <template #default>
      <SfEllipsis :length="200" :tooltip="document.name">
        {{ document.name }}
      </SfEllipsis>
    </template>
  </SfDocumentPill>
</template>
<script lang="ts" setup>
import { ExtraDocumentLinkTypes, StoredDocument } from './../types'

import { computed } from 'vue'

import { useDocumentView } from '../composables/use-document-view'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfDocumentPill from '@app/shared/vue/components/sf-document-pill.vue'
import SfEllipsis from '@app/shared/vue/components/sf-ellipsis.vue'

interface Props {
  document: StoredDocument
  isDisabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  isDisabled: false,
})

const I18n = useI18n()

const isProposedDocument = computed(() => {
  return props.document.linkType === ExtraDocumentLinkTypes.ProposedDocument
})

const { viewingUrl } = useDocumentView(props.document)

const emit =
  defineEmits<{
    'import-document:delete': [value: number | string]
  }>()

function handleDelete() {
  emit('import-document:delete', props.document.id)
}
</script>
